import { ReactNode, useState } from 'react';
import Alert from 'react-bootstrap/Alert';

interface IAlertDimissibleProps {
    variant: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark'
    title?: string;
    children: ReactNode;
    className?: string;
}

// alertas do bootstrap
const AlertDimissible= ({ variant, children, title, className }: IAlertDimissibleProps) => {
    const [show, setShow] = useState<boolean>(true);

    if (show) {
        return (
            <Alert variant={variant} onClose={() => setShow(false)} dismissible className={className}>
                <Alert.Heading>{title}</Alert.Heading>
                {children}
            </Alert>
        );
    }
}

export { AlertDimissible }